import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import Clinics from './Clinics';
import UserContext from '../../UserContext';

const ClinicsContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [clinicsList, setClinicsList] = useState([]);
    const [originalClinicsList, setOriginalClinicsList] = useState([]);

    const { setClinic, setCurrentMenuItem, user } = useContext(UserContext);

    const getBuildingsList = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/profile/${user.id}/clinics`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setClinicsList(res.data);
                // const buildingsList = user.clinics.map((userClinic) => {
                //     return res.data.find((clinic) => clinic.id === userClinic.id).buildings
                // })

                // setClinicsList(buildingsList);
                // if (buildingsList.length === 1 && buildingsList[0].length === 1) {
                //     setClinic(buildingsList[0][0]);
                //     // history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/service/${buildingsList[0][0].id}/${buildingsList[0][0].buildingId}`);
                //     history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/referral/${buildingsList[0][0].id}/${buildingsList[0][0].buildingId}`);
                //     // history.push(`direct/${res.data[0].id}/${res.data[0].buildings[0].buildingId}`);
                // } else {
                //     setClinicsList(buildingsList);
                // }
            })
            .catch((err) => {
                console.log(err);
                // setErrorMessage(err.response && err.response.data.message);
                setIsLoading(false);
            });
    }

    const getClinicsList = () => {
      setIsLoading(true);
      axios.get(`${process.env.REACT_APP_API}api/v1.0/profile/${user.id}`, {
          headers: {
              ...unauthHeaders,
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          }
      })
          .then((res) => {
              // setIsLoading(false);
              setOriginalClinicsList(res.data[0]?.clinics);
          })
          .catch((err) => {
              console.log(err);
              // setErrorMessage(err.response && err.response.data.message);
              setIsLoading(false);
          });
    }

    useEffect(() => {
        if (user.clinics) {
            getClinicsList();
            getBuildingsList();
            setCurrentMenuItem('schedule');
        }
    }, [user])

    useEffect(() => {
      if(user.clinics && clinicsList.length && user.clinics.length === 1 && originalClinicsList.length) {
        handleClickCardClinic(clinicsList[0]?.buildingId, clinicsList[0]?.id);
      }
    }, [user, clinicsList, originalClinicsList])

    const handleClickCardClinic = (buildingId, clinicId) => {
        setClinic(clinicsList.find((item) => item.buildingId === buildingId));

        const selectedBuilding = clinicsList.find((item) => item.buildingId === buildingId);
        const timeZoneOffset = originalClinicsList.find((item) => selectedBuilding?.id === item?.id)?.timeZoneOffset;
        localStorage.setItem('timeZoneOffset', timeZoneOffset);

        history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/referral/${clinicId}/${buildingId}`);
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            <Clinics
                isLoading={isLoading}
                clinicsList={clinicsList}
                handleClickCardClinic={handleClickCardClinic}
            />
        </>
    )
}

export default ClinicsContainer;
